import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  mode: "light",
  user: null,
  token: null,
  subscriptionStatus: "",
  expiresAt: null,
  collapsedSidebar: false,
  currentXp: 0,
  selectedAvatar: 0,
  isFirstTime: false,
  lastLogin: null,
  onboardingStep: "welcome",
  isOnboardingResuming: false,

  wordCounts: {
    young: 0,
    mature: 0,
    buried: 0,
    new: 0,
    loaded: false
  },

  hintProgress: {
    flashcardFrontHintShown: false,
    flashcardBackHintShown: false,
    videoHintShown: false,
    nudgeDayTwoShown: false,
    nudgeDayThreeShown: false,
    nudgeDayFourShown: false,
    grammarHintShown: false,
    lastNudgeShownDay: null
  },

  loginDay: 1,

  deckData: {
    my: null,
    starter: null
  },

  showTextReminder: false
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setShowTextReminder: (state, action) => {
      state.showTextReminder = action.payload
    },

    incrementWordCount: (state, action) => {
      const { type } = action.payload
      if (state.wordCounts[type] !== undefined) {
        state.wordCounts[type] += 1
      }
    },
    decrementWordCount: (state, action) => {
      const { type } = action.payload
      if (state.wordCounts[type] !== undefined) {
        state.wordCounts[type] = Math.max(0, state.wordCounts[type] - 1)
      }
    },
    setWordCounts: (state, action) => {
      state.wordCounts = { ...action.payload, loaded: true }
    },
    setHintProgress: (state, action) => {
      state.hintProgress = { ...action.payload }
    },
    setHintProgressFlag: (state, action) => {
      const { key, value } = action.payload
      state.hintProgress[key] = value
    },
    setLoginDay: (state, action) => {
      state.loginDay = action.payload;
    },
    setDeckDataForDeck: (state, action) => {
      const { name, data } = action.payload
      state.deckData[name] = data
    },

    setOnboardingState: (state, action) => {
      state.onboardingStep = action.payload.onboardingStep;
    },
    setIsOnboardingResuming: (state, action) => {
      state.isOnboardingResuming = action.payload.isOnboardingResuming;
    },

    setMode: (state) => {
      state.mode = state.mode === "light" ? "dark" : "light";
    },
    setLogin: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.expiresAt = action.payload.expiresAt;
    },

    setAccessToken: (state, action) => {
      state.token = action.payload.token;
      state.expiresAt = action.payload.expiresAt;
    },
    setExpiresAt: (state, action) => {
      state.expiresAt = action.payload.expiresAt;
    },

    setLogout: (state) => {
      state.user = null;
      state.token = null;
      state.expiresAt = null;
      state.subscriptionStatus = null;
      state.starterDeckId = null;
      state.myDeckId = null;
      state.currentXp = 0;
      state.selectedAvatar = 0;
      state.isFirstTime = false;
      state.mode = "light";
      state.wordCounts = {
        young: 0,
        mature: 0,
        buried: 0,
        loaded: false
      }
    },
    setSubscriptionStatus: (state, action) => {
      state.subscriptionStatus = action.payload.subscriptionStatus;
    },
    setStreak: (state, action) => {
      state.user.streak = action.payload.streak;
    },
    setName: (state, action) => {
      state.user.firstName = action.payload.name;
    },
    setLastLogin: (state, action) => {
      state.lastLogin = action.payload.lastLogin;
    },
    setCollapsedSidebar: (state) => {
      state.collapsedSidebar = state.collapsedSidebar === false ? true : false;
    },
    setCurrentXp: (state, action) => {
      state.currentXp = action.payload.currentXp
    },
    setSelectedAvatar: (state, action) => {
      state.selectedAvatar = action.payload.selectedAvatar
    },
    setIsFirstTime: (state, action) => {
      state.isFirstTime = action.payload.isFirstTime
    }
  },
});

export const {
  setMode,
  setAccessToken,
  setLogin,
  setLogout,
  setSubscriptionStatus,
  setLastLogin,
  setCollapsedSidebar,
  setCurrentXp,
  setSelectedAvatar,
  setName,
  setStreak,
  setExpiresAt,
  setIsFirstTime,
  setOnboardingState,
  setIsOnboardingResuming,

  incrementWordCount,
  decrementWordCount,
  setWordCounts,

  setHintProgress,
  setHintProgressFlag,
  setLoginDay,

  setDeckDataForDeck,

  setShowTextReminder
} = authSlice.actions;
export default authSlice.reducer;
